import styled from 'styled-components'

import { Card } from '@/components/ui/card'

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: theme.space['16'],
  minHeight: 0,
}))

export const CheckinsContainer = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: '40rem',
  overflow: 'hidden',
}))

export const AllocationCard = styled(Card)(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  boxShadow: 'none',
  height: 'auto',
}))

export const SectionHeader = styled.div(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
}))

export const SectionTitleGroup = styled.div(({ theme }) => ({
  alignItems: 'baseline',
  display: 'flex',
  gap: theme.space['8'],
}))

export const HeaderActions = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.space['8'],
}))

export const FieldsTable = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexDirection: 'column',
}))

export const FieldRow = styled.div(({ theme }) => ({
  '&:last-child': {
    borderBottom: 'none',
  },

  alignItems: 'center',
  borderBottom: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  display: 'grid',
  gap: theme.space['24'],
  gridTemplateColumns: '20rem minmax(0, 1fr)',
  minHeight: '4.8rem',
  // Note: 1px subtracted vertically to account for input border (1px each side)
  padding: `calc(${theme.space['8']} - 1px) ${theme.space['16']}`,
}))

export const FieldValue = styled.span(({ theme }) => ({
  alignItems: 'center',
  color: theme.colors.black800,
  display: 'flex',
  fontSize: '1.4rem',
  paddingLeft: theme.space['10'],
}))
